import React, { useContext, useEffect, useState } from 'react';
import classNames from 'classnames';
import { SearchBox, useSearchBox } from 'react-instantsearch-hooks-web';
import { useQueryClient } from '@tanstack/react-query';

import HitTab from './search_results/HitTab';
import SearchResults from './search_results/SearchResults';
import logo from '../../../lib/images/logo.svg';
import { QueryContext } from '../../../App';

export default function Home() {
  const queryClient = useQueryClient();
  const { query, refine } = useSearchBox();
  const { searchQuery, setSearchQuery } = useContext(QueryContext);
  const [content, setContent] = useState('all');

  queryClient.invalidateQueries([
    'orders',
    'company',
    'applications',
    'documents',
  ]);

  useEffect(() => {
    if (searchQuery) refine(searchQuery);
  }, []);

  useEffect(() => {
    if (query) setSearchQuery(query);
  }, [query]);

  const getContent = () => {
    switch (content) {
      case 'all':
        return <SearchResults query={searchQuery} />;
      case 'companies':
      case 'orders':
      case 'credit_key_applications':
      case 'users':
        return <HitTab type={content} query={searchQuery} />;
      default:
        return <SearchResults query={searchQuery} />;
    }
  };

  return (
    <div className="max-w-[90%] mx-auto">
      <img src={logo} alt="Credit Key Logo" className="w-1/4 m-auto my-10" />
      <div className="mt-4 mb-2">
        <SearchBox
          classNames={{
            root: 'relative mb-2',
            input:
              'block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 ph-no-capture',
            submit:
              'absolute inset-y-0 left-1.5 top-5 flex pl-3 pointer-events-none',
            submitIcon: 'w-3.5 h-3.5 text-dark-gray',
            reset: 'hidden',
          }}
          placeholder="Begin typing to search for companies ..."
        />
        <p className="text-sm text-light-gray pl-2">
          Search by company name, phone, or order key
        </p>
      </div>
      {searchQuery && (
        <>
          <div className="hidden sm:block">
            <div className="border-b border-gray-200">
              <nav
                className="-mb-px flex space-x-8 cursor-pointer"
                aria-label="Tabs"
              >
                <div
                  onClick={() => setContent('all')}
                  className={classNames(
                    content === 'all'
                      ? 'border-primary-blue text-primary-blue'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium',
                  )}
                >
                  All
                </div>
                <div
                  onClick={() => setContent('companies')}
                  className={classNames(
                    content === 'companies'
                      ? 'border-primary-blue text-primary-blue'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium',
                  )}
                >
                  Companies
                </div>
                <div
                  onClick={() => setContent('orders')}
                  className={classNames(
                    content === 'orders'
                      ? 'border-primary-blue text-primary-blue'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium',
                  )}
                >
                  Orders
                </div>
                <div
                  onClick={() => setContent('credit_key_applications')}
                  className={classNames(
                    content === 'credit_key_applications'
                      ? 'border-primary-blue text-primary-blue'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium',
                  )}
                >
                  Applications
                </div>
                <div
                  onClick={() => setContent('users')}
                  className={classNames(
                    content === 'users'
                      ? 'border-primary-blue text-primary-blue'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium',
                  )}
                >
                  Users
                </div>
              </nav>
            </div>
          </div>
          {getContent()}
        </>
      )}
    </div>
  );
}
